import React, { useContext, useState } from "react";
import { CategoryContext } from "../../categoryContext";
import AllSubjectsBanner from "../../Components/AllSubjectsBanner";
import AllSubjectsCategory from "../../Components/AllSubjectsCategory";
import BonusSection from "../../Components/BonusSection";
import AskQue from "../../Components/AskQue";
import WorldWide from "../../Components/WorldWide";
import RecentlyAskedQue from "../../Components/RecentlyAskedQue";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import CommonForm from "../HomePage/Form/CommonForm";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import StaticText from "./StaticText";
const AllSubjects = () => {
  const { categoryId } = useContext(CategoryContext);
  const subCategoryId = "655659b9b9cbef8acade1d7c";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => setIsModelOpen(!isModelOpen);


  const breadCrumbData=[
     { label: "Home", path: "/" },
    { label: "Subjects"},
  ]
  return (
    <div>

       <div className="container">
      <div className="row mt-2 mb-2 m-0">
        <BreadCrumb items={breadCrumbData} />
      </div>
      </div>
      <AllSubjectsBanner setIsModelOpen={setIsModelOpen} />
      <StaticText/>
      <AllSubjectsCategory />
      <RecentlyAskedQue />
      <div className="mt-5">
        <AskQue />
      </div>
      <BonusSection subCategoryId={categoryId} />
      <WorldWide />
      {isModelOpen && (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps:1,
          }}
          subCategory={subCategoryId}
        />
      )}
      <ScrollTop />
    </div>
  );
};

export default AllSubjects;
